import { FC } from 'react';
import { RouterProvider } from 'react-router-dom';
import { appRouter } from '../../../AppRouter';

interface AppRouterProviderProps {}

export const AppRouterProvider: FC<AppRouterProviderProps> = () => {
    return <RouterProvider router={appRouter} />;
};
